import styled from "styled-components";

export const FooterDiv = styled.div`
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  .mds-button {
    width: 100%;
  }

  .disclaimer-text {
    max-width: 270px;
    margin-left: auto;
    margin-right: auto;
  }
  .disclaimer-text.no-max-width {
    max-width: unset;
  }
`;

export const FooterButtonDiv = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
`;
